<template>
  <div class="centered-container" v-resize="onResize">
    <md-content v-bind:class="{ 'md-elevation-3': !isMobile }" style="border-radius: 5px;">
      <div class="tittle">
        <img alt="Logo Realtec" src="@/assets/img/logorealtec.svg" />

        <div class="subtitle">EMS WEB</div>
      </div>

      <div class="form">
        <md-field :class="getValidationClass('email')">
          <label>Login</label>
          <md-input
            id="email"
            name="email"
            v-on:keyup.enter="validateUser"
            v-model="form.email"
            autofocus
          ></md-input>
          <span class="md-error" v-if="!$v.form.email.required">Informe seu login</span>
        </md-field>

        <md-field md-has-password :class="getValidationClass('password')">
          <label for="password">Senha</label>
          <md-input
            id="password"
            v-on:keyup.enter="validateUser"
            name="password"
            v-model="form.password"
            type="password"
          ></md-input>
          <span
            class="md-error"
            v-if="!$v.form.password.required"
          >Você precisa de uma senha para entrar</span>
        </md-field>
      </div>

      <div class="actions md-layout md-alignment-center">
        <!--<md-button  class="btn_login"  @click="validateUser">Entrar</md-button>-->
        <button class="btn_login_new" @click="validateUser">Entrar</button>
        <a href="/resetpassword" class="resetpass">Recuperar senha</a>
      </div>

      <div class="loading-overlay" v-if="loading">
        <v-progress-linear color="#2a5377" indeterminate rounded height="6" style="width: 170px;"></v-progress-linear>
      </div>
    </md-content>
    <img v-if="!isMobile" alt="bg" class="background" :src="backgroundImage" />
    <md-snackbar :md-active.sync="msg">{{msg}}</md-snackbar>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
var jwt = require("jsonwebtoken");
var md5 = require("MD5");
import {
  required,
  email,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
import { setTimeout } from "timers";

import { api } from "@/services/index.js";
import store from '@/store/index.js'

export default {
  name: "Login",
  data() {
    return {
      isMobile: false,
      msg: false,
      attt: false,
      url: process.env.VUE_APP_API_URL + "/emsweb/userlogin",
      loading: false,
      form: {
        email: null,
        password: null
      }
    };
  },
  props: {
    backgroundImage: {
      type: String,
      default: require("@/assets/img/bg_login.png")
    }
  },
  validations: {
    form: {
      email: {
        required
      },
      password: {
        required
      }
    }
  },
  created() {
    localStorage.clear();
    store.dispatch('clearUserData')
  },
  methods: {
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },
    validateUser() {
      this.$v.$touch();
      !this.$v.$invalid
        ? this.auth()
        : (this.msg = "Você deve preencher todos os campos.");      
    },
    async auth() {
      debugger
      var self = this;
      self.loading = true;

      if (self.form.email === null) {
        self.msg = "Você deve informar um e-mail.";
        self.loading = false;
        return;
      }
      if (self.form.password === null) {
        self.msg = "Você deve informar uma senha.";
        self.loading = false;
        return;
      }

      var padroes = ['123', 'ASD', '456', '789', '147', '258', '369', '159', '357', 'QWE', 'ZXC', 'REAL'];
      var regex = [/(.+)\1\1/, /([0-9]+).*\1.*\1/]
      var weak = false;

      padroes.forEach ((val) => {
        if (self.form.password.toUpperCase().includes(val) || self.form.password.toUpperCase().includes(val.split("").reverse().join("")))
          weak = true;
      })

      regex.forEach ((val) => {
        debugger
        if (val.test(self.form.password))
          weak = true;
      })

      if (self.form.password.length < 5)
        weak = true;

      if (weak == true){
        alert("Senha muito fraca.\nAcesse o CRM e redefina sua senha para uma mais forte.\nA senha não deve conter sequências simples de caracteres e deve possuir no mínimo 5 dígitos.");
        self.loading = false;
        return;
      }

      var data = {
        login: self.form.email,
        password: md5(self.form.password.toLowerCase())
      };

      await self.axios
        .post(self.url, data)
        .then(r => {
          if (r.data.success) {            
            localStorage.setItem("token", r.data.token);
            localStorage.setItem("refreshToken", r.data.refreshToken);

            var user = JSON.stringify(jwt.decode(r.data.token));
            localStorage.setItem("user", user);
            store.dispatch("setUserData", jwt.decode(r.data.token));

            self.msg = "Login efetuado com sucesso!";

            self.loading = false;

            setTimeout(() => {
              self.$router.push({ name: "Dashboard" });
            }, 1000);
          } else if (r.data.Error) {
            self.loading = false;
            self.msg = r.data.Message;
          }
        })
        .catch(() => {
          self.loading = false;
          self.msg = "O servidor não respondeu como esperado.";
        });

      self.msg = false;
    },    
  },
};
</script>
<style scoped>
html {
  overflow: hidden !important;
  background-color: rgb(27, 27, 27) !important;
}
.loading-overlay {
  border-radius: 20px !important;
}
</style>


<style lang="scss">
.resetpass {
  color: #2a5377 !important;
  margin-top: 30px;
  transition: all 0.5s, font-weight 0.5s;
}
.resetpass:hover {
  color: #2a5377 !important;
  transform: scale(1.1);
  font-weight: 500;
}
.subtitle {
  top: 55px;
  right: 50px;
  font-size: 15px;
  margin-bottom: 10px;
  color: #848688;
  position: absolute;
}
.btn_login_new {
  background-color: #2a5377 !important;
  padding: 10px 20px 10px 20px;
  font-weight: 500;
  border: 1px solid transparent;
  color: #fff;
  border-radius: 10px;
  width: 100%;
  transition: background-color 0.5s, color 0.5s;
}
.btn_login_new:hover {
  background-color: transparent !important;
  padding: 10px 20px 10px 20px;
  font-weight: 500;
  border: 1px solid #2a5377;
  color: #2a5377;
  border-radius: 10px;
  width: 100%;
}
.centered-container {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  position: absolute;
  height: 100%;
  .title {
    position: relative;
    text-align: center;
    margin-bottom: 30px;
    img {
      margin-bottom: 16px;
      max-width: 180px;
    }
  }
  .actions {
    .md-button {
      margin: 0;
    }
  }
  .form {
    margin-bottom: 60px;
  }
  .background {
    opacity: 0.3;
    position: fixed;
    height: auto;
    width: 100%;
    top: 0%;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 0;
    animation: animatedBackground 40s ease infinite;
  }

  @keyframes animatedBackground {
    0% {
      top: -10%;
      zoom: 1.5;
      opacity: 0.3;
    }
    50% {
      top: 0%;
      opacity: 1;
      zoom: 1;
    }
    100% {
      top: -10%;
      opacity: 0.3;
      zoom: 1.5;
    }
  }

  .md-content {
    z-index: 1;
    padding: 40px;
    width: 100%;
    max-width: 360px;
    position: relative;
  }
  .loading-overlay {
    z-index: 10;
    top: 0;
    left: 0;
    right: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.md-field .md-input-action {
  top: 15px !important;
}
</style>
